(ns frontend.view.grid.tasks-grid.columns
  (:require
   [frontend.view.grid.tasks-grid.db :as db]
   [frontend.state.current-session :as session]))

;;list of all columns in default order
(def column-keys-all
  [:task/assignee
   :common/created-on
   :task/due
   :task/title
   :task/message
   :task/completed?
   :common/related-entities-oppo
   :common/related-entities-fundraising-opportunities
   :common/related-entities-sales-opportunities
   :common/related-entities-exit-opportunities
   :common/related-entities-fund
   :common/related-entities-investor
   :common/related-entities-company
   :common/related-entities-real-estate
   :common/related-entities-fof-asset
   :common/related-entities-other-asset
   :common/related-entities-person
   :common/related-entities-holdings
   :common/related-entities-sale-agreements
   :common/related-entities-fund-commitment

   :task/source])

(def column-keys-common
  [:task/assignee
   :common/created-on
   :task/message])

(def columns-webentry-tasks
  (concat column-keys-common
          [:task/due
           :task/source
           :webentry-task/asset-name
           :webentry-task/first-name
           :webentry-task/last-name]))

(def columns-user-tasks
  [:task/assignee
   :common/created-on
   :task/due
   :task/title
   :task/message
   :common/related-entities-oppo
   :common/related-entities-fundraising-opportunities
   :common/related-entities-sales-opportunities
   :common/related-entities-exit-opportunities
   :common/related-entities-fund
   :common/related-entities-investor
   :common/related-entities-company
   :common/related-entities-real-estate
   :common/related-entities-fof-asset
   :common/related-entities-other-asset
   :common/related-entities-person
   :common/related-entities-holdings
   :common/related-entities-sale-agreements
   :common/related-entities-fund-commitment
   :task/completed?])

(def columns-email-tasks
  (concat column-keys-common
          [:task/title]))

(def columns-common-v2
  [:task/assignee
   :task/due
   :common/created-on
   :task/completed?
   :task/title
   :task/message])

(defn column-keys
  []
  (if (session/has-feature-access? :feature/tasks-kanban)
    ; Todo quick fix to show all task types in same grid
    columns-common-v2

    (let [cols (case (:tasks-view @db/tasks)
                 :task.type/webentry columns-webentry-tasks
                 :task.type/simple columns-user-tasks
                 :task.type/email columns-email-tasks
                 column-keys-common)]
      cols)))

;;default set of selected columns
(defn default-columns
  []
  (column-keys))

;;always selected:
(def mandatory?
  (set column-keys-common))
